const helpers = {
    successAlert(text, title = 'Success') {
        return Swal.fire({
            icon: 'success',
            title: title,
            text: text,
        })
    },
    errorAlert(text, title = 'Error') {
        return Swal.fire({
            icon: 'error',
            title: title,
            text: text,
        })
    },
    warningAlert(text, title = 'Warning') {
        return Swal.fire({
            icon: 'warning',
            title: title,
            text: text,
        })
    },
    infoAlert(text, title = 'Info') {
        return Swal.fire({
            icon: 'info',
            title: title,
            text: text,
        })
    },
    confirmAlert(text, title = 'Info', buttonText, icon = 'warning') {
        return Swal.fire({
            title: title,
            text: text,
            icon: icon,
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: buttonText
        })
    }
}

export default helpers
